import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColorSwatchPicker } from '../UI';
import type { ColorSwatchOption } from '../UI';
import {
  LOCATION_COLOR_PALETTE,
  type LocationColorId
} from '../../constants/locationColors';

interface LocationColorPickerProps {
  colorId: LocationColorId;
  onSelect: (colorId: LocationColorId) => void;
}

// Location-palette instance of the shared swatch picker: same control as the
// treatment-plan template colour, scoped to the location colours.
export const LocationColorPicker = ({ colorId, onSelect }: LocationColorPickerProps) => {
  const { t } = useTranslation();

  const options = useMemo<ColorSwatchOption<LocationColorId>[]>(
    () =>
      LOCATION_COLOR_PALETTE.map((color) => ({
        id: color.id,
        color: color.base,
        label: t(color.labelKey)
      })),
    [t]
  );

  return (
    <ColorSwatchPicker
      label={t('config-loc-color')}
      options={options}
      selectedId={colorId}
      onSelect={onSelect}
    />
  );
};
